// extracted by mini-css-extract-plugin
export default {"box":"loginPage_box__lmeTj","box__form":"loginPage_box__form__PUCFW"};